import { render, staticRenderFns } from "./SingleNews.vue?vue&type=template&id=7cd820fd&scoped=true&"
import script from "./SingleNews.vue?vue&type=script&lang=js&"
export * from "./SingleNews.vue?vue&type=script&lang=js&"
import style0 from "./SingleNews.vue?vue&type=style&index=0&id=7cd820fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd820fd",
  null
  
)

export default component.exports